import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { LogRocketOutlet } from './LogRocketOutlet';
import { useSession } from '../hooks/useSession';

export function RequireAuth() {
  const location = useLocation();
  const { hasToken, user } = useSession();

  if (!hasToken) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    console.error('RequireAuth: Not authorized');
    return <Navigate to="/login" state={{ from: location }} />;
  } else if (user?.uses_default_password && location.pathname !== '/account') {
    return <Navigate to="/account" state={{ from: location }} />;
  }

  return (
    <LogRocketOutlet>
      <Outlet />
    </LogRocketOutlet>
  );
}
